export default __webpack_public_path__ + "static/media/mountain-4.1293a54a.png";